<template xmlns="http://www.w3.org/1999/html">
  <div class="tianyi-new">
    <img class="logo" src="/static/images/tianyi/logo.png">

    <!-- 溯源信息卡：白卡圆角底边嵌领取积分按钮（半内半外） -->
    <div class="info-card">
      <div class="info-main">
        <div class="info-left">
          <img class="info-title" src="/static/images/tianyi/scxx.png">
          <span class="info-line">查询数码：{{ antiCode.substring(0, 16) }}</span>
          <span class="info-line">产品名称：{{ displayProductName }}</span>
          <span class="info-line">原生产地：中国台湾省</span>
          <hr class="info-hr">
          <img class="info-title2" src="/static/images/tianyi/zsmcs.png">
          <span class="info-line">首次扫码：{{ firstQueryTime }}</span>
          <span class="info-line">最新扫码：{{ preQueryTime }}</span>
        </div>
        <div class="info-product" :class="{ 'info-product-zhsgd': productNo === 'zhsgd' }">
          <img v-if="uiConfig.productImg" :src="uiConfig.productImg" class="product-img">
        </div>
      </div>
      <img src="/static/images/tianyi/v2/lqjf.png" class="btn-lqjf" @click="getjf">
    </div>

    <!-- 福利区：正常态保持原绝对定位；仅视口被压矮时 compact 限制左图高度 -->
    <div class="welfare" :class="{ compact: welfareCompact }">
      <div class="welfare-card welfare-card-left">
        <img v-if="uiConfig.leftImg" :src="uiConfig.leftImg" class="welfare-bg welfare-bg-left" :class="{ 'welfare-bg-left-zhsgd': productNo === 'zhsgd' }">
        <div class="welfare-btn-wrap">
          <img src="/static/images/tianyi/v2/mscy.png" class="btn-action" @click="addWecom">
        </div>
      </div>
      <div class="welfare-card welfare-card-right">
        <img src="/static/images/tianyi/v2/right.png" class="welfare-bg welfare-bg-right">
        <div class="welfare-btn-wrap">
          <img src="/static/images/tianyi/v2/jrhy.png" class="btn-action">
          <wx-open-launch-weapp
            id="launch-btn"
            class="welfare-weapp"
            :appid="miniAppId"
            :username="miniAppOriginalId"
            :path="miniAppPage">
            <script type="text/wxtag-template">
              <div style="width: 100%; height: 40px;"></div>
            </script>
          </wx-open-launch-weapp>
        </div>
      </div>
    </div>

    <!-- 底部权益 -->
    <div class="icons">
      <img src="/static/images/tianyi/zpbz.png">
      <img src="/static/images/tianyi/v2/huiyuantequan.png">
      <img src="/static/images/tianyi/v2/cfzd.png">
      <img src="/static/images/tianyi/pzsy.png">
    </div>
    <div class="footer-text">
      <span class="footer-line"></span>
      <span class="footer-label">健养堂海外会员店</span>
      <span class="footer-line"></span>
    </div>

    <div v-show="isShow">
      <div id="fixedBg"></div>
      <p class="loading_p" id="loadP">
        <img src="/static/images/loadding.gif" />
      </p>
    </div>

    <div id="background" class="modal-layer" v-if="showWeCom" @click="closeWeCom">
      <div id="jfwin" class="modalwin"></div>
      <img src="/static/images/tianyi/addwecom.png" class="modal-hit"
        style="position:absolute;width: 80vw;z-index: 5;top: 30vh;left: 12vw;" @click.stop />
    </div>

    <div id="background" class="modal-layer" v-if="showUnbindProductDialog" @click="closeUnbindProduct">
      <div id="jfwin" class="modalwin"></div>
      <img src="/static/images/tianyi/failjf.png" class="modal-hit"
        style="position:absolute;width: 80vw;z-index: 5;top: 30vh;left: 12vw;user-select: none;-webkit-user-select: none;-moz-user-select: none;-ms-user-select: none;"
        @click.stop />
      <div class="modal-pass"
        style="position:absolute;width: 100vw;z-index: 5;top: 30vh;display: flex;flex-direction: column;align-items: center;justify-content: center;">
        <img src="/static/images/tianyi/jflqtip.png" class="modal-hit"
          style="width: 50vw;z-index: 5;margin-top: 7vh;margin-left: -2.8vw;" @click.stop />
        <img src="/static/images/tianyi/qrcode.png" class="modal-hit"
          style="width: 33vw;z-index: 5;margin-top: 1vh;margin-left: -2.8vw;" @click.stop />
        <img src="/static/images/tianyi/changan.png" class="modal-hit"
          style="width: 33vw;z-index: 5;margin-top: 1vh;margin-left: -2.8vw;" @click.stop />
      </div>
    </div>

    <div id="background" class="modal-layer" v-if="showJfDialog" @click="closeJfDialog">
      <div id="jfwin" class="modalwin"></div>
      <div class="modal-pass"
        style="position:absolute;width: 100vw;z-index: 6;top: 20vh;text-align: center;display: flex;flex-direction: column;align-items: center;justify-content: center;">
        <img src="/static/images/tianyi/jfpoup.png" class="modal-hit" style="width: 90vw;margin-left: 3vw;" @click.stop />
        <wx-open-launch-weapp id="launch-btn" class="modal-hit"
          style="width: 30vw; height: 5vh; position: absolute;z-index: 5;bottom: 1vh;" :appid="miniAppId"
          :username="miniAppOriginalId" :path="miniAppPage" @click.stop>
          <script type="text/wxtag-template">
            <img src="https://zishu-image.oss-cn-shanghai.aliyuncs.com/ljdh.png" style="width: 100%;" />
          </script>
        </wx-open-launch-weapp>
      </div>
      <div class="modal-pass"
        style="position:absolute;width: 100vw;z-index: 5;top: 20vh;text-align: center;display: flex;flex-direction: column;align-items: center;justify-content: center;">
        <img src="/static/images/tianyi/sun.png" style="width: 100vw;" />
      </div>
      <div class="modal-pass"
        style="position:absolute;width: 100vw;z-index: 6;top: 31vh;display: flex;flex-direction: column;align-items: center;justify-content: center;">
        <img src="/static/images/tianyi/jflogo.png" class="modal-hit" style="width: 30vw;z-index: 5;" @click.stop />
        <div class="modal-hit" style="margin-top: 0.3vh;display: flex;align-items: center;justify-content: center;" @click.stop>
          <span style="font-size: 9vw;font-weight:bold;color: rgb(35, 72, 42);margin-top: -0.2vh;">{{ jfValue }}</span>&nbsp;
          <img src="/static/images/tianyi/jftext.png" style="width: 14vw;z-index: 5;" />
        </div>
      </div>
    </div>

    <div id="background" class="modal-layer" v-if="showJfCFDialog" @click="closeJfCFDialog">
      <div id="jfwin" class="modalwin"></div>
      <div class="modal-pass"
        style="position:absolute;width: 100vw;z-index: 6;top: 20vh;text-align: center;display: flex;flex-direction: column;align-items: center;justify-content: center;">
        <img src="/static/images/tianyi/jfcflq.png" class="modal-hit" style="width: 90vw;margin-left: 3vw;" @click.stop />
        <wx-open-launch-weapp id="launch-btn" class="modal-hit"
          style="width: 30vw; height: 5vh; position: absolute;z-index: 5;bottom: 1vh;" :appid="miniAppId"
          :username="miniAppOriginalId" :path="miniAppPage" @click.stop>
          <script type="text/wxtag-template">
            <img src="https://zishu-image.oss-cn-shanghai.aliyuncs.com/ljdh.png" style="width: 100%;" />
          </script>
        </wx-open-launch-weapp>
      </div>
      <div class="modal-pass"
        style="position:absolute;width: 100vw;z-index: 5;top: 20vh;text-align: center;display: flex;flex-direction: column;align-items: center;justify-content: center;">
        <img src="/static/images/tianyi/sun.png" style="width: 100vw;" />
      </div>
    </div>
  </div>
</template>

<style scoped src="../../assets/css/index.css"></style>
<style scoped src="../../assets/css/style.css"></style>

<script>
import { antiQuery, getInfoByCode, getJSSDK, getTemplate, getWechatAuth, registerByOpenId, joinActivity } from '../../api/api'
import wx from 'weixin-js-sdk'
import moment from 'moment'

const UI_CONFIG = {
  hblsdtl: {
    productImg: '/static/images/tianyi/v2/pingzi.png',
    leftImg: '/static/images/tianyi/v2/left.png',
    displayName: '健养堂®EX综合蔬果锭'
  },
  zhsgd: {
    productImg: '/static/images/tianyi/v2/syz.png',
    leftImg: '/static/images/tianyi/v2/left2.png',
    displayName: '健养堂®EX综合蔬果锭'
  }
}

export default {
  name: 'TianYiTraceNew',
  data() {
    return {
      isShow: false,
      showWeCom: false,
      eno: '138707141135',
      showJfDialog: false,
      deptId: '',
      authCode: '',
      antiCode: '',
      firstQueryTime: '',
      preQueryTime: '',
      jfValue: 0,
      productName: '',
      // 优先用 Gateway 传入的 productNo，避免先出默认特浓图再跳到应急装
      productNo: '',
      miniAppId: 'wx64ce7aa94b232424',
      miniAppOriginalId: 'gh_4bd8f3695d61',
      miniAppPage: 'pages/home/dashboard/index',
      showUnbindProductDialog: false,
      showJfCFDialog: false,
      activityId: null,
      userToken: '',
      // iOS 微信底栏等导致可视高度变矮时，限制左图以免盖住按钮
      welfareCompact: false
    }
  },
  computed: {
    uiConfig() {
      return UI_CONFIG[this.productNo] || {
        productImg: '',
        leftImg: '',
        displayName: ''
      }
    },
    displayProductName() {
      return this.uiConfig.displayName || this.productName
    }
  },
  methods: {
    addWecom() {
      this.showWeCom = true
    },
    getjf() {
      if (this.productNo == null || this.productNo == undefined) {
        this.showUnbindProductDialog = true
      } else {
        this.joinActivity()
      }
    },
    closeUnbindProduct() {
      this.showUnbindProductDialog = false
    },
    closeJfDialog() {
      this.showJfDialog = false
    },
    closeJfCFDialog() {
      this.showJfCFDialog = false
    },
    closeWeCom() {
      this.showWeCom = false
    },
    updateWelfareCompact() {
      const w = window.innerWidth || 1
      const h = (window.visualViewport && window.visualViewport.height) || window.innerHeight || 1
      // 卡高约 34.6vh；左图按宽度约需 0.53*w。卡高明显矮于图时进入紧凑态
      const cardH = 0.346 * h
      const imgH = 0.4416 * w * 0.9883 * (644 / 531)
      this.welfareCompact = cardH < imgH + 0.08 * w
    },
    async getResult() {
      this.isShow = true
      const params = this.$route.query
      const code = params.c
      this.antiCode = code
      this.authCode = params.wyAuthCode
      var antiResult = await antiQuery(this.eno, code)
      var data = antiResult.data
      if (data == null || data.code == '500') {
        this.isShow = false
        alert('防伪查询失败,请联系管理员')
      } else if (data.code == '300106') {
        this.isShow = false
        alert(data.message)
      } else {
        var codeInfo = await getInfoByCode(code)
        this.isShow = false

        this.firstQueryTime = data.data.firstQueryTime
        if (data.code == '300101') {
          this.preQueryTime = data.data.firstQueryTime
        } else {
          this.preQueryTime = moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
        }
        this.deptId = data.data.deptId
        this.productName = codeInfo.data.data.productName
        this.productNo = codeInfo.data.data.productNo
        const isCliskJf = sessionStorage.getItem('clickJf')
        if (isCliskJf == 'true') {
          this.joinActivity()
        }
      }
      this.isShow = false
    },
    getAuth() {
      const url = window.location.href.split('#')[0]
      getWechatAuth(url, 'wx8ae619a1dbc50c9e', 1).then(res => {
        const data = res.data
        window.location.href = data
      }).catch(err =>
        alert('获取微信授权失败' + err)
      )
    },
    async getTemplate() {
      const res = await getTemplate(this.deptId)
      if (res.data.data != null) {
        this.activityId = res.data.data.activityId
      }
    },
    async joinActivity() {
      await this.getTemplate()

      if (this.activityId == 0 || this.activityId == '' || this.activityId == null || this.activityId == undefined) {
        alert('此活动已结束')
      } else {
        if (this.authCode == undefined || this.authCode == '' || this.authCode == null) {
          sessionStorage.setItem('clickJf', true)
          this.getAuth()
          return
        }
        const registerResult = await registerByOpenId(this.eno, this.authCode)
        if (registerResult.data.code == '500') {
          alert('用户登录异常，请联系管理员')
          return
        } else {
          this.userToken = registerResult.data.data.token
        }
        const data = {
          code: this.antiCode,
          activityId: this.activityId,
          authCode: this.authCode,
          userToken: this.userToken
        }
        const result = await joinActivity(data)
        sessionStorage.removeItem('clickJf')
        if (result.data.code == '200') {
          this.jfValue = result.data.data.giftValue
          this.showJfDialog = true
        } else if (result.data.code == '500001') {
          this.showJfCFDialog = true
        } else if (result.data.code == '500') {
          alert('系统异常，请稍后再试')
        }
      }
    },
    getWxJs() {
      const url = encodeURIComponent(window.location.href.split('#')[0])
      getJSSDK(url, 'wx8ae619a1dbc50c9e').then(res => {
        const data = res.data.data
        wx.config({
          debug: false,
          appId: data.appId,
          timestamp: data.timestamp,
          nonceStr: data.nonceStr,
          signature: data.signature,
          openTagList: ['wx-open-launch-weapp', 'wx-open-launch-app'],
          jsApiList: [
            'checkJsApi',
            'onMenuShareTimeline',
            'onMenuShareAppMessage',
            'onMenuShareQQ',
            'onMenuShareWeibo',
            'onMenuShareQZone',
            'hideMenuItems',
            'showMenuItems',
            'hideAllNonBaseMenuItem',
            'showAllNonBaseMenuItem',
            'translateVoice',
            'startRecord',
            'stopRecord',
            'onVoiceRecordEnd',
            'playVoice',
            'onVoicePlayEnd',
            'pauseVoice',
            'stopVoice',
            'uploadVoice',
            'downloadVoice',
            'chooseImage',
            'previewImage',
            'uploadImage',
            'downloadImage',
            'getNetworkType',
            'openLocation',
            'getLocation',
            'hideOptionMenu',
            'showOptionMenu',
            'closeWindow',
            'scanQRCode',
            'chooseWXPay',
            'openProductSpecificView',
            'addCard',
            'chooseCard',
            'openCard'
          ]
        })
        wx.ready(function () {
          wx.hideMenuItems({
            menuList: [
              'menuItem:copyUrl',
              'menuItem:openWithQQBrowse',
              'menuItem:openWithSafari',
              'menuItem:email',
              'menuItem:readMode',
              'menuItem:originPage',
              'menuItem:delete',
              'menuItem:editTag'
            ]
          })
        })
      }).catch(err =>
        alert('获取微信授权失败' + err)
      )
    }
  },
  created() {
    const pn = this.$route.query && this.$route.query.productNo
    if (pn) {
      this.productNo = pn
    }
    this.getWxJs()
    this.getResult()
  },
  mounted() {
    this.updateWelfareCompact()
    window.addEventListener('resize', this.updateWelfareCompact)
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', this.updateWelfareCompact)
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateWelfareCompact)
    if (window.visualViewport) {
      window.visualViewport.removeEventListener('resize', this.updateWelfareCompact)
    }
  }
}
</script>

<style scoped>
.tianyi-new {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: rgb(18, 73, 39);
  overflow-x: hidden;
  overflow-y: auto;
  padding-bottom: 3vh;
  box-sizing: border-box;
}

.logo {
  width: 40vw;
  margin-top: 3vh;
}

.info-card {
  width: 92vw;
  position: relative;
  background-color: white;
  border-radius: 15px;
  margin-top: 2vh;
  margin-bottom: 2.8vh; /* 给半外按钮留空 */
  overflow: visible;
}

.info-main {
  width: 100%;
  display: flex;
  min-height: 30.5vh; /* 再加高约 5% */
  border-radius: 15px;
  overflow: hidden;
}

.info-left {
  width: 63%;
  display: flex;
  flex-direction: column;
  padding-bottom: 2.5vh; /* 给底部嵌按钮留出内侧空间 */
}

.info-title {
  width: 40%;
  margin-top: 2.6vh;
  margin-left: 2vh;
}

.info-title2 {
  width: 65%;
  margin-top: 1.2vh;
  margin-left: 2vh;
}

.info-line {
  color: rgb(58, 58, 58);
  font-size: 2.8vw;
  margin-left: 2vh;
  margin-top: 0.6vh;
}

.info-hr {
  border: none;
  height: 1px;
  margin-left: 2vh;
  margin-top: 0.8vh;
  background-color: rgb(224, 224, 224);
  width: 85%;
}

.info-product {
  width: 37%;
  position: relative;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: 2.6vh;
}

/* 仅应急装：产品图略往左，不影响特浓 */
.info-product-zhsgd {
  justify-content: flex-start;
  padding-left: 0;
}

.info-product-zhsgd .product-img {
  transform: translateX(-1.5vw);
}

.product-img {
  height: 90%;
  max-height: 27.9vh; /* 随信息卡再加高约 5% */
  object-fit: contain;
  margin-bottom: 0;
}

/* 嵌在白卡底边圆角上：一半在内一半在外 */
.btn-lqjf {
  width: 30%;
  position: absolute;
  left: 50%;
  bottom: 0;
  transform: translate(-50%, 50%);
  z-index: 3;
}

.welfare {
  width: 92vw;
  margin-top: 1.8vh;
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  min-height: 34.6vh; /* 再减约 3%，少留按钮下方空白 */
  overflow: visible;
}

.welfare-card {
  width: 48%;
  background-color: white;
  border-radius: 10px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 34.6vh;
}

/* 左卡允许「再来一盒」角标超出右上圆角 */
.welfare-card-left {
  overflow: visible;
  z-index: 2;
}

.welfare-card-right {
  overflow: visible; /* 允许 50 元图顶部超出圆角 */
  z-index: 1;
}

.welfare-bg {
  position: absolute;
  object-fit: contain;
}

/*
 * 左卡图：略离左边框；右缘到右卡左边框的空隙 = 两卡间距的 30%
 * 两卡宽各 48%，间距 4%；伸进间距 70% ⇒ 相对左卡溢出约 5.83%
 */
.welfare-bg-left {
  width: calc(100% - 7% + 5.83%); /* ≈ 98.83%，右缘约在卡宽 105.83% */
  max-height: none;
  height: auto;
  top: -1%; /* 相对上边框约 106%，略超出顶部 */
  left: 7%;
  right: auto;
}

/* 仅应急装：左卡图略放大，并稍往左，避免贴到右卡左边框；不影响特浓 */
.welfare-bg-left-zhsgd {
  transform: scale(1.03) translateX(-1.2vw);
  transform-origin: top left;
}

.welfare-bg-right {
  width: 112%;
  max-height: 81%;
  top: -1%; /* 顶部可超出圆角 */
  left: 50%;
  transform: translateX(-50%); /* 水平居中 */
}

/* 左右按钮同一高度、水平居中对齐 */
.welfare-btn-wrap {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 3.2vw;
  z-index: 3;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* 仅 iOS 底栏等压矮视口时缩小左图；固定宽高盒 + 贴右上，缩小时仍超出右边框 */
.welfare.compact .welfare-bg-left {
  width: calc(100% - 7% + 5.83%);
  height: calc(100% - 12vw);
  max-height: calc(100% - 12vw);
  object-fit: contain;
  object-position: top right;
}

/* 授权后紧凑态保持原缩放贴右，不再额外左移 */
.welfare.compact .welfare-bg-left-zhsgd {
  transform: scale(1.03);
  transform-origin: top right;
}

.btn-action {
  width: 52%;
  display: block;
  position: relative;
  z-index: 1;
}

.welfare-weapp {
  position: absolute;
  left: 24%;
  right: 24%;
  top: 0;
  bottom: 0;
  z-index: 4;
}

.icons {
  width: 88vw;
  margin-top: 2.5vh;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.icons img {
  height: 10vh;
}

.footer-text {
  width: 72vw;
  margin-top: 2.4vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.footer-line {
  flex: 1;
  height: 1px;
  background-color: rgba(180, 210, 180, 0.55);
}

.footer-label {
  flex-shrink: 0;
  margin: 0 3vw;
  color: rgba(255, 255, 255, 0.9);
  font-size: 2.8vw;
  letter-spacing: 0.15vw;
  white-space: nowrap;
}

/* 弹层需高于领取积分按钮(z-index:3)和福利区按钮；fixed 避免被页面内容顶到视口外 */
.modal-layer {
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  z-index: 20;
}

.modalwin {
  position: absolute;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  z-index: 4;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: rgba(3, 3, 3, 0.6);
}

/* 全宽装饰层不拦截点击，点阴影可关闭；弹窗本体 modal-hit 自行承接点击 */
.modal-pass {
  pointer-events: none;
}

.modal-hit {
  pointer-events: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/TianYi/TraceNew.vue